import { render } from "./Allnotice.vue?vue&type=template&id=264409a2&scoped=true"
import script from "./Allnotice.vue?vue&type=script&lang=js"
export * from "./Allnotice.vue?vue&type=script&lang=js"

import "./Allnotice.vue?vue&type=style&index=0&id=264409a2&scoped=true&lang=css"

import exportComponent from "/var/www/html/youthmanna/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264409a2"]])

export default __exports__